
export default function Logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('admin_token');
    window.location.href = '/login';
    return null;
}